module.exports = __webpack_public_path__ + "img/KrummeBäume.0aece917.svg";